var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.description),expression:"description"}],staticClass:"c-tooltip"},[_vm._v("i")])}
var staticRenderFns = []

export { render, staticRenderFns }